import { useRef, useState } from "react";
import { Play, Pause } from "lucide-react";
import { BRAND } from "@/lib/brand";

export const InstitutionalVideo = () => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);

  const toggle = () => {
    const v = ref.current;
    if (!v) return;
    if (v.paused) {
      v.play();
      setPlaying(true);
    } else {
      v.pause();
      setPlaying(false);
    }
  };

  return (
    <section
      id="institucional"
      data-testid="institutional-video"
      className="relative bg-white pt-16 lg:pt-24 pb-6"
    >
      <div className="max-w-[1400px] mx-auto px-4 lg:px-6">
        <div className="max-w-3xl mb-8 lg:mb-10 px-2">
          <div className="flex items-center gap-3 mb-4 reveal">
            <span className="divider-gold" />
            <span className="tracking-eyebrow text-gold">Institucional</span>
          </div>
          <h2 className="font-display text-3xl lg:text-4xl font-bold text-navy leading-[1.1] tracking-[-0.02em] reveal">
            A engenharia por trás da continuidade operacional.
          </h2>
        </div>

        <div className="relative rounded-3xl overflow-hidden bg-navy shadow-2xl shadow-navy/20 group reveal">
          <video
            ref={ref}
            data-testid="institutional-video-player"
            src={BRAND.institutionalVideoUrl}
            className="w-full h-auto max-h-[78vh] object-cover"
            playsInline
            preload="metadata"
            onEnded={() => setPlaying(false)}
            onPlay={() => setPlaying(true)}
            onPause={() => setPlaying(false)}
          />

          {!playing && (
            <button
              type="button"
              onClick={toggle}
              aria-label="Reproduzir vídeo institucional"
              data-testid="institutional-video-play"
              className="absolute inset-0 flex items-center justify-center bg-navy/40 hover:bg-navy/25 transition-colors"
            >
              <div className="relative">
                <span
                  className="absolute inset-0 rounded-full bg-white/20 blur-xl animate-pulse"
                  aria-hidden
                />
                <div className="relative w-24 h-24 md:w-28 md:h-28 rounded-full bg-white text-navy shadow-2xl flex items-center justify-center group-hover:scale-105 transition-transform">
                  <Play className="w-9 h-9 ml-1" />
                </div>
              </div>
              <div className="absolute bottom-6 left-6 md:left-10 text-white">
                <div className="tracking-eyebrow text-gold text-[10px] mb-1.5">
                  Assista o vídeo institucional
                </div>
                <div className="font-display text-xl md:text-2xl font-semibold max-w-md leading-tight">
                  Mantemos operações em movimento.
                </div>
              </div>
            </button>
          )}

          {playing && (
            <button
              type="button"
              onClick={toggle}
              aria-label="Pausar vídeo institucional"
              data-testid="institutional-video-pause"
              className="absolute bottom-4 right-4 w-12 h-12 rounded-full bg-white/90 text-navy flex items-center justify-center shadow-xl hover:bg-white transition-colors"
            >
              <Pause className="w-5 h-5" />
            </button>
          )}
        </div>
      </div>
    </section>
  );
};
